import React from 'react';
import { NoRowsOverlay } from '../../feature-object-browser/ui/NoRowsOverlay';

export function UnassignedOverlay() {
	return <NoRowsOverlay text="No title assignment" />;
}
